<template>
  <div class="container">
    <b-modal no-close-on-backdrop centered ref="documento-modal" title="" hide-footer id="modalC" size="l">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(putDocumento)">
          <ModalDocumento :currentDocumento="currentDocumento" :optionsDocumentos="optionsDocumentos" @submit.prevent />
        </form>
      </ValidationObserver>
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="modal-confirm-dialog" hide-footer id="modal-confirm-dialog">
      <h4 class="text-center">¿Seguro que quiere eliminar el documento?</h4>
      <h5 class="text-center"></h5>
      <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-dialog')">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="deleteDocumento">OK</b-button>
    </b-modal>

    <h4 class="cardD">Información de los Documentos a Notificar</h4>
    <div class="mt-4">
      <label for="btn-add-document">Agregar documento</label>
      <b-button id="btn-add-document" variant="success" class="btn-fill spaceL" size="sm"
        @click="addDocumento">+</b-button>
    </div>

    <div>
      <b-table ref="table" hover :fields="fieldsCuadro" :items="notificacion.documentos">
        <template #cell(acciones)="{ item }">
          <b-button variant="warning" size="sm" v-b-tooltip.hover title="Editar" class="editBtn"
            @click="editDocumento(item)">
            <b-icon-pencil />
          </b-button>
          <b-button variant="danger" size="sm" v-b-tooltip.hover title="Eliminar" @click="predeleteDocumento(item.id)">
            <b-icon-trash />
          </b-button>
        </template>
      </b-table>
    </div>

    <div class="row mt-1" v-if="notificacion.documentos.length > 0">
      <div class="col-12 d-flex">
        <b-form-checkbox class="orange" id="checkbox-fad" v-model="notificacion.fad">
          Los documentos a notificar serán firmados mediante Firma Digital
        </b-form-checkbox>
      </div>
    </div>

    <div class="mt-4">
      <div>
        <b-button type="submit" class="btn-fill orange-btn bottom2" size="m">Continuar</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import ModalDocumento from "@/views/clients/procesos/notificaciones/infoBase/modales/ModalDocumento.vue";

import { CatDocumentosApi } from "@/api";

import { useNotificacionStore } from '@/stores';

export default {
  name: "DocumentosANotificar",

  components: { ModalDocumento },

  setup() {
    const notificacion = useNotificacionStore();

    return { notificacion };
  },

  computed: {
    fieldsCuadro() {
      let fieldsCuadro = [
        { key: "index", label: "", class: "text-center" },
        { key: "tipo", label: "Tipo", class: "text-center" },
        { key: "paginas", label: "No. Páginas", class: "text-center" },
        { key: "acciones", label: "Acciones", class: "text-center" },
      ];
      return fieldsCuadro;
    },
  },

  created() {
    this.getCatDocumentosNotificaciones();
  },

  data() {
    return {
      selectedDocumento: null,
      currentDocumento: null,
      currentDocumentoId: null,

      optionsDocumentos: [],
      id_anexo: 0
    }
  },

  methods: {
    async getCatDocumentosNotificaciones() {
      try {
        this.loading = true;

        const { value } = await CatDocumentosApi.list({
          page: 0,
          registersPerPage: 0,
          categoria: "notificaciones"
        });

        this.optionsDocumentos = value.filter(d => !d.tipo).map(d => ({
          text: d.documento,
          value: d.id
        })).sort((x, y) => {
          if (x.text === "Otro") return 1;
          if (y.text === "Otro") return -1;
          return x.text.localeCompare(y.text, undefined, { sensitivity: 'base' });
        });;

        // value.filter(d => !d.tipo).forEach(element => {
        //   const obj = { text: element.documento, value: element.id };
        //   this.optionsDocumentos.push(obj);
        // });

        this.getIdAnexo();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    getIdAnexo() {
      this.optionsDocumentos.forEach(element => {
        if (element.text === 'Anexo') {
          this.id_anexo = element.value;
        }
      })
    },

    addDocumento() {
      this.$refs["documento-modal"].show();
      this.currentDocumento = {};
    },

    putDocumento() {
      if (this.currentDocumento.descripcion) {
        this.currentDocumento.tipo = this.currentDocumento.descripcion;
      } else {
        this.optionsDocumentos.forEach(element => {
          if (element.value === this.currentDocumento.catDocumentos_id) {
            this.currentDocumento.tipo = element.text;
          }
        })
      }

      if (!this.currentDocumento.id) {
        const id = this.notificacion.documentos.length + 1;

        this.currentDocumento.id = id;
        this.notificacion.documentos.push(this.currentDocumento);
      }

      const index = this.notificacion.documentos.findIndex(o => o.id === this.currentDocumento.id);

      this.notificacion.documentos[index].tipo = this.currentDocumento.tipo;

      if (this.currentDocumento.tiene_anexo) {
        this.addAnexo(this.currentDocumento, index + 1);
      } else {
        if (this.notificacion.documentos[index + 1]) {
          if (this.notificacion.documentos[index + 1].anexoDe) {
            this.notificacion.documentos.splice(index + 1, 1);
          }
        }
      }

      this.$refs.table.refresh();
      this.$refs["documento-modal"].hide();
    },

    editDocumento(item) {
      let documentoPadre = item;
      if (item.anexoDe) {
        this.notificacion.documentos.forEach(documento => {
          if (documento.id == item.anexoDe) {
            documentoPadre = documento;
          }
        })
      }

      item = documentoPadre;
      this.currentDocumento = item;

      this.$refs["documento-modal"].show();
    },

    addAnexo(documento, index_to_slice) {
      if (this.notificacion.documentos[index_to_slice]) {
        if (this.notificacion.documentos[index_to_slice].anexoDe) {
          this.notificacion.documentos.splice(index_to_slice, 1);
        }
      }

      const currentDocumento = {
        catDocumentos_id: this.id_anexo,
        paginas: documento.paginas_anexo,
        tipo: "Anexo",
        anexoDe: documento.id
      };

      this.notificacion.documentos.splice(index_to_slice, 0, currentDocumento);
    },

    predeleteDocumento(id) {
      this.currentDocumentoId = id;
      this.$refs["modal-confirm-dialog"].show();
    },

    deleteDocumento() {
      const index = this.notificacion.documentos.findIndex(o => o.id === this.currentDocumentoId);

      if (this.notificacion.documentos[index].anexoDe) {
        this.notificacion.documentos.forEach(documento => {
          if (documento.id == this.notificacion.documentos[index].anexoDe) {
            documento.tiene_anexo = false;
          }
        });
      }

      if (this.notificacion.documentos[index + 1]) {
        if (this.notificacion.documentos[index + 1].anexoDe) {
          this.notificacion.documentos.splice(index + 1, 1);
        }
      }

      this.notificacion.documentos.splice(index, 1);

      this.$refs.table.refresh();
      this.$refs["modal-confirm-dialog"].hide();
    },
  }
}
</script>

<style scoped>
.spaceL {
  margin-left: 20px;
}

.control-label {
  margin-left: 30px;
  position: absolute;
  vertical-align: middle;
}

.custom-control-label {
  color: #ea640b !important;
}
</style>
